"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
const invariant_1 = __importDefault(require("invariant"));
const account_1 = require("../../account");
const currencies_1 = require("../../currencies");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
function formatAccountSpecifics(account) {
    const { elrondResources } = account;
    (0, invariant_1.default)(elrondResources, "elrond account expected");
    const unit = (0, account_1.getAccountUnit)(account);
    const formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true,
    };
    let str = " ";
    if (account.spendableBalance) {
        str += (0, currencies_1.formatCurrencyUnit)(unit, account.spendableBalance, formatConfig) + " spendable. ";
    }
    else {
        str += " 0 spendable.";
    }
    if (elrondResources && elrondResources.nonce) {
        str += "\n  nonce : " + elrondResources.nonce;
    }
    if (elrondResources && elrondResources.delegations) {
        let delegated = new bignumber_js_1.default(0);
        let undelegating = new bignumber_js_1.default(0);
        let rewards = new bignumber_js_1.default(0);
        for (const delegation of elrondResources.delegations) {
            delegated = delegated.plus(delegation.userActiveStake);
            undelegating = delegation.userUndelegatedList.reduce((sum, undelegation) => sum.plus(undelegation.amount), undelegating);
            rewards = rewards.plus(delegation.claimableRewards);
        }
        str +=
            delegated && delegated.gt(0)
                ? `\n  delegated: ${unit ? (0, currencies_1.formatCurrencyUnit)(unit, delegated, formatConfig) : delegated}`
                : undelegating && undelegating.gt(0)
                    ? `\n  undelegating: ${unit ? (0, currencies_1.formatCurrencyUnit)(unit, undelegating, formatConfig) : undelegating}`
                    : rewards && rewards.gt(0)
                        ? `\n  rewards: ${unit ? (0, currencies_1.formatCurrencyUnit)(unit, rewards, formatConfig) : rewards}`
                        : "";
    }
    return str;
}
function formatOperationSpecifics(op, unit) {
    const { amount } = op.extra;
    return (amount === null || amount === void 0 ? void 0 : amount.gt) && amount.gt(0)
        ? " amount: " +
            `${unit
                ? (0, currencies_1.formatCurrencyUnit)(unit, new bignumber_js_1.default(amount), {
                    showCode: true,
                    disableRounding: true,
                }).padEnd(16)
                : amount}`
        : "";
}
function fromOperationExtraRaw(extraRaw) {
    const extra = {};
    if (extraRaw.amount) {
        extra.amount = new bignumber_js_1.default(extraRaw.amount);
    }
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    const extraRaw = {};
    if (extra.amount) {
        extraRaw.amount = extra.amount.toString();
    }
    return extraRaw;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports.default = {
    formatAccountSpecifics,
    formatOperationSpecifics,
    fromOperationExtraRaw,
    toOperationExtraRaw,
};
//# sourceMappingURL=account.js.map